import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { PreloadAllModules, provideRouter, withComponentInputBinding, withEnabledBlockingInitialNavigation, withInMemoryScrolling, withPreloading, withRouterConfig, withViewTransitions } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import {APP_ID, APP_INITIALIZER} from '@angular/core';
import { DatePipe, DecimalPipe} from '@angular/common';
import {KlaDataService} from './shared/tools/services/kla.data.service';
import {KlaHttpService} from './shared/tools/services/kla.http.service';
import {KlaEmitterService} from './shared/tools/services/kla.emitter.service';
import {HIGHCHARTS_MODULES} from 'angular-highcharts';
import {KlaDynamicScriptLoaderService} from './shared/tools/services/kla.dynamic-script-loader.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { klaRoutes } from "./app.routes";
import { provideClientHydration } from '@angular/platform-browser';
import { MenuItems } from './core/menu/menu-items/menu-items';
import { PageTitleService } from './core/page-title/page-title.service';
import { DataService } from './shared/services/data.service';

function initializeApp(dataService: KlaDataService) {
  return () => {
    try {
      dataService.getData();
      return Promise.resolve(); // APP_INITIALIZER needs to return a Promise
    } catch (error) {
      console.error('Failed to initialize app:', error);
      return Promise.reject(error);
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(),
    provideClientHydration(),
    provideRouter(klaRoutes, 
      withInMemoryScrolling({ anchorScrolling: "enabled", scrollPositionRestoration: "enabled" }),
      withPreloading(PreloadAllModules),
      withComponentInputBinding(),
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
        urlUpdateStrategy: 'eager',
        canceledNavigationResolution: 'replace'
      })
    ),
    DecimalPipe,
    DatePipe,
    KlaEmitterService,
    KlaDataService,
    KlaHttpService,
    KlaDynamicScriptLoaderService,
    importProvidersFrom(BrowserAnimationsModule),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true,
      deps: [KlaDataService]
    },
    {
      provide: APP_ID,
      useValue: 'serverApp'
    },
    MenuItems,
    PageTitleService,
    DataService,
  ]
};